import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Component, Input, AfterContentInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AccountWithRenewalData } from '../account.model';
import { LoanInfoDto, MessageService, HorizontalListData, SimpleDialogService, CommonActionKey, LoanStatus } from 'common';
import { AccountService } from '../account.service';
import { AccountProfileStatusWidgetAdapter } from './account-profile-status-widget.data';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'ifb-account-profile-status-widget',
    templateUrl: './account-profile-status-widget.component.html',
    styleUrls: ['./account-profile-status-widget.component.scss'],
    providers: [AccountProfileStatusWidgetAdapter],
    standalone: false
})
export class AccountProfileStatusWidgetComponent implements AfterContentInit, OnChanges {
  @Input()
  data: AccountProfileStatusWidgetData;

  @Input()
  editStatus: boolean;

  @Input()
  editInfo: boolean;

  listItems: HorizontalListData[];

  readonly LoanStatus = LoanStatus;

  constructor(
    private readonly accountService: AccountService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly adapter: AccountProfileStatusWidgetAdapter,
    private readonly simpleDialogService: SimpleDialogService,
  ) { }

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.data);
  }

  ngAfterContentInit(): void {
    this.accountService.obsCurrentLoan
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        if (res) {
          this.data.account = res;
          this.listItems = this.adapter.adaptListData(this.data);
        }
      });
  }

  deleteAccount(): void {
    this.simpleDialogService.openSimpleConfirmDialog(`Are you sure you want to delete Account #${this.data.account.loanNumber}?`)
      .subscribe((result: CommonActionKey) => {
        if (result === CommonActionKey.Confirm) {
          this.accountService.delete(this.data.account.id)
          .pipe(catchError((error) => this.handleDeleteError(error)))
          .subscribe(() => {
            this.router.navigate(['account']);
            this.messageService.success(`Account #${this.data.account.loanNumber} deleted successfully`);
          })
        }
      })
  }

  private handleDeleteError(error: unknown): Observable<never> {
    this.messageService.error(error);
    return throwError(error);
  }
}

export interface AccountProfileStatusWidgetData {
  account: AccountWithRenewalData;
  accountInfo: LoanInfoDto;
}
